import { useSelector } from 'react-redux';
import { Alert } from 'foundations-components/transitional/components/Alert';
import { ButtonWrapper } from 'foundations-components/transitional/components/ButtonWrapper';
import { Button } from 'foundations-components/transitional/components/Button';
import { Link } from 'foundations-components/transitional/components/Link';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { getCurrentInboxId } from 'conversations-inbox-lib/unified-inbox/public/selectors';
import { getCurrentInboxAccessUrl } from '../../urls/inboxSettingsUrls';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const AdminNonMemberWarning = ({
  closeWarning
}) => {
  const currentInboxId = useSelector(getCurrentInboxId);
  const currentInboxAccessUrl = currentInboxId ? getCurrentInboxAccessUrl({
    inboxId: currentInboxId
  }) : '/';
  return /*#__PURE__*/_jsx(Alert, {
    type: "warning",
    titleText: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "conversations-inbox-ui.unified-inbox.warning.title"
    }),
    closeable: true,
    onClose: closeWarning,
    children: /*#__PURE__*/_jsxs(ButtonWrapper, {
      children: [/*#__PURE__*/_jsx("span", {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "conversations-inbox-ui.unified-inbox.warning.info"
        })
      }), /*#__PURE__*/_jsx(Link, {
        href: currentInboxAccessUrl,
        children: /*#__PURE__*/_jsx(Button, {
          size: "extra-small",
          use: "tertiary",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "conversations-inbox-ui.unified-inbox.warning.button"
          })
        })
      })]
    })
  });
};
AdminNonMemberWarning.displayName = 'AdminNonMemberWarning';
export default AdminNonMemberWarning;